import React from "react";
import energyImg from "../assets/energy.webp"; // Replace with your actual image path
import { motion } from "framer-motion";
import smartGrid from "../assets/smart-grid.png";
import energyAnalytics from "../assets/energy-analytics.png";
import predictiveMaintenance from "../assets/predictive-maintenance.png";
import remoteAsset from "../assets/remote-asset.png";
import renewable from "../assets/renewable.png";
import realtimeIcon from "../assets/icon-realtime.svg";
import efficiencyIcon from "../assets/icon-efficiencyy.svg";
import automationIcon from "../assets/icon-automationn.svg";
import costIcon from "../assets/icon-cost.svg";
import sustainabilityIcon from "../assets/icon-sustainability.svg";
import industrialIcon from "../assets/icon-industrial.svg";
import gridIcon from "../assets/icon-gridd.svg";
import buildingIcon from "../assets/icon-building.svg";
import renewableIcon from "../assets/icon-renewable.svg";
import buildingImage from "../assets/choose-us-building.webp";
import iconShield from "../assets/icon-shield.svg";
import iconPuzzle from "../assets/icon-puzzle.svg";
import iconChip from "../assets/icon-chip.svg";
import { useNavigate } from 'react-router-dom'; 
import { Helmet } from "react-helmet-async";

import { useState, useEffect,useRef } from "react";

const EnergyHero = () => {
const FeatureCard = ({ image, title, bgColor, className = "" }) => (
  <div
    className={`rounded-[20px] p-6 flex flex-col items-center justify-center text-center ${bgColor} ${className}`}
    style={{ height: "172px", width: "100%" }}
  >
    <img
      src={image}
      alt={title}
      className="w-[80px] h-auto mb-2 object-contain"
    />
    <h3 className="text-base font-semibold text-black leading-tight">
      {title}
    </h3>
  </div>
);
    const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2 },
  }),
};
const solutions = [
  {
    title: "Industrial Energy Management",
    desc: "Reduce operational costs with smart metering and equipment-level analytics.",
    icon: industrialIcon,
   
  },
  {
    title: "Smart Grid & Utilities",
    desc: "Empower grid automation, load forecasting, and energy theft detection.",
    icon: gridIcon,
    
  },
  {
    title: "Commercial Buildings",
    desc: "Enhance occupant comfort and energy savings with smart HVAC, lighting, and occupancy sensors.",
    icon: buildingIcon,
    
  },
  {
    title: "Renewable Energy IoT",
    desc: "Monitor solar/wind performance, optimize battery usage, and ensure grid compliance.",
    icon: renewableIcon,
    
  },
];

const features = [
  {
    title: "Smart Grid & Metering",
    image: smartGrid,
    bg: "bg-[#A8F29E]",
  },
  {
    title: "Energy Monitoring & Analytics",
    image: energyAnalytics,
    bg: "bg-[#1A1A1A] text-white",
  },
  {
    title: "Predictive Maintenance",
    image: predictiveMaintenance,
    bg: "bg-[#7883FF] text-white",
  },
  {
    title: "Remote Asset Management",
    image: remoteAsset,
    bg: "bg-[#D3DCFF]",
  },
  {
    title: "Renewable Integration",
    image: renewable,
    bg: "bg-[#F7E27D]",
  },
];
const featuress = [
  {
    icon: iconShield,
    title: "Proven IoT Platform",
    desc: "Built on a reliable, secure, and field-tested architecture powering energy systems across industries.",
    bg: "#E7FBE7",
    border: "#C5EBC4",
  },
  {
    icon: iconPuzzle,
    title: "Seamless API Integration",
    desc: "Easily connects with your existing systems for fast deployment and smooth data exchange.",
    bg: "#E5F0FF",
    border: "#D2E1FA",
  },
  {
    icon: iconChip,
    title: "Edge + Artificial Intelligence",
    desc: "Combines edge computing with AI to enable real-time decisions, faster response, and smarter automation.",
    bg: "#FFF4D9",
    border: "#FDE8B4",
  },
];
const benefits = [
  { line1: "Real-Time", line2: "Monitoring", icon: realtimeIcon },
  { line1: "Operational", line2: "Efficiency", icon: efficiencyIcon },
  { line1: "Automated", line2: "Control", icon: automationIcon },
  { line1: "Cost", line2: "Reduction", icon: costIcon },
  { line1: "Sustainability", line2: "", icon: sustainabilityIcon },
];
 const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
      
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);


  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
     <Helmet>
        <title>IoT Energy Solutions | Smart & Sustainable Energy Management</title>
        <meta name="description" content="Optimize your energy systems with LENTERA’s IoT solutions. Enable real-time monitoring, predictive maintenance, smart grid management, and renewable energy integration for enhanced efficiency, cost reduction, and sustainable operations."/>
        <meta name="keywords" content="LENTERA energy IoT, automated energy control, real-time energy monitoring, sustainable energy solutions, AI-powered energy systems.
"/>
      </Helmet>
    <section className="w-full bg-[#10101E] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
{/* LEFT CONTENT */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <p className="text-[#FFFFFF] font-semibold text-sm mb-3 uppercase tracking-wider">
        Energy
      </p>
      <h1 className="text-[#FFFFFF] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
         Empowering the Future<br className="hidden lg:block" />
        of Energy with IoT
        
      </h1>
      <p className="text-[#FFFFFF] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
        Unlock smarter, cleaner, and more efficient energy systems through
        intelligent IoT technologies.
      </p>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center lg:justify-end"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      viewport={{ once: true }}
    >
      <img
            src={energyImg}
            alt="Energy IoT Illustration"
            className="w-[380px] sm:w-[460px] md:w-[520px] lg:w-full max-w-[600px] h-auto object-contain"
          />
    </motion.div>

  </div>
</section>


  

<section className="bg-[#FAFAFA] py-12 px-4 sm:px-6 lg:px-20">
  {/* Section Heading */}
 <div className="bg-[#f9f9f9] py-20">
  <div className="max-w-[1200px] mx-auto text-center px-4">
    {/* Top Badge */}
    <div className="inline-block px-4 py-2 bg-[#e5e5e5] text-gray-700 text-sm font-semibold rounded-full mb-4">
      OUR SERVICES
    </div>

    {/* Heading */}
    <h2 className="text-[36px] md:text-[48px] font-extrabold text-[#1a1a1a]">
      Key Benefits / Features
    </h2>

    {/* Description */}
    <p className="mt-4 text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
      We transform the energy sector with real-time insights, remote monitoring, and smart control to boost efficiency and reduce costs.
    </p>
  </div>
</div>

  {/* Cards Grid */}
  <div className="max-w-screen-xl mx-auto grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-auto">
    
    {/* Smart Grid & Metering */}
    <div className="bg-[#90EE90] rounded-3xl p-6 flex flex-col justify-center items-center text-center">
      <img
        src={smartGrid}
        alt="Smart Grid & Metering"
        className="w-full max-w-[264px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A]">Smart Grid & Metering</h4>
    </div>

    {/* Energy Monitoring & Analytics */}
    <div className="bg-[#1A1A1A] text-white rounded-3xl p-6 flex flex-col justify-center items-center sm:col-span-2 lg:col-span-2">
      <h4 className="text-lg font-semibold mb-4">Energy Monitoring & Analytics</h4>
      <img
        src={energyAnalytics}
        alt="Energy Monitoring & Analytics"
        className="w-full max-w-[320px] h-auto object-contain"
      />
    </div>

    {/* Predictive Maintenance */}
    <div className="bg-[#6A6BFF] text-white rounded-3xl p-6 flex flex-col justify-center items-center text-center sm:row-span-2">
      <h4 className="text-lg font-semibold mb-4">Predictive Maintenance</h4>
      <img
        src={predictiveMaintenance}
        alt="Predictive Maintenance"
        className="w-full max-w-[360px] h-auto object-contain"
      />
    </div>

    {/* Remote Asset Management */}
    <div className="bg-[#DCE5FF] rounded-3xl p-6 flex flex-col justify-center items-center sm:col-span-2 lg:col-span-2">
      <img
        src={remoteAsset}
        alt="Remote Asset Management"
        className="w-full max-w-[272px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A] text-center">
        Remote Asset <br /> Management
      </h4>
    </div>

    {/* Renewable Integration */}
    <div className="bg-[#FFE47E] rounded-3xl p-6 flex flex-col justify-center items-center text-center">
      <img
        src={renewable}
        alt="Renewable Integration"
        className="w-full max-w-[134px] h-auto mb-4 object-contain"
      />
      <h4 className="text-lg font-semibold text-[#1A1A1A]">Renewable Integration</h4>
    </div>
  </div>
</section>


   <section className="w-full bg-[#1C1C1C] text-white font-poppins px-6 md:px-12 py-20">
      {/* Header */}
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          {/* Left Title Area */}
          <div className="flex-1">
            <div className="bg-[#2c2c2c] text-xs px-4 py-1 rounded-full font-medium inline-block mb-4">
              WHY IOT ENERGY?
            </div>
            <h2 className="text-white text-[32px] sm:text-[38px] lg:text-[44px] font-extrabold leading-tight">
              Why you need us for your <br /> business growth?
            </h2>
          </div>

          {/* Right Description */}
          <div className="flex-1 max-w-xl text-[14px] sm:text-[15px] text-[#DDDDDD] leading-[1.7]">
            IoT brings real-time visibility, smart automation, and data-driven insights to energy systems—enabling improved efficiency, reduced costs, and sustainable operations.
          </div>
        </div>

        {/* Card Section */}
        <div className="mt-14 bg-[#111111] rounded-[36px] px-4 sm:px-6 py-8 overflow-x-auto">
          <div className="flex flex-nowrap gap-5 sm:gap-6 min-w-max">
            {benefits.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-start bg-[#2a2a2a] px-5 py-5 rounded-2xl min-w-[185px] sm:min-w-[210px] text-left shadow-sm"
              >
                <img
                  src={item.icon}
                  alt={item.line1 + ' ' + item.line2}
                  className="w-[28px] h-[28px] mb-3"
                />
                <p className="text-sm sm:text-[15px] font-semibold leading-tight">
                  {item.line1} {item.line2 && <br />} {item.line2}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    <section className="w-full bg-[#F6FAFF] py-16 px-4 sm:px-8 font-poppins">
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
          Solutions We Offer
        </h2>
        <p className="text-sm sm:text-base text-gray-500">
          Smart solutions for energy efficiency and control. Optimized for
          industries, buildings, and utilities.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {solutions.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-[20px] p-6 shadow-md flex flex-col gap-4"
          >
            <img
              src={item.icon}
              alt={item.title}
              className="w-[58px] h-[58px] object-contain"
            />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 leading-tight">
              {item.title}
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
     <section className="bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        
        {/* Left Content */}
        <div className="space-y-6">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1A1A1A]">Why Choose Us</h2>
          <p className="text-lg text-[#4B4B4B] max-w-xl">
            We combine intelligent IoT technology with deep energy expertise to deliver reliable, scalable, and future-ready solutions.
          </p>
          <img
            src={buildingImage}
            alt="Wind and Solar Energy"
            className="w-full max-w-[520px] object-contain mx-auto sm:mx-0"
          />
        </div>

        {/* Right Content */}
        <div className="flex flex-col gap-6 w-full">
          {/* Card 1 */}
          <div className="flex items-center bg-[#F0FFE9] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconShield} alt="IoT Shield" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Proven IoT Platform</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Built on a reliable, secure, and field-tested architecture powering energy systems across industries.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="flex items-center bg-[#EAF1FF] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconPuzzle} alt="API Icon" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Seamless API Integration</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Easily connects with your existing systems for fast deployment and smooth data exchange.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="flex items-center bg-[#FFF9E7] rounded-3xl p-6 shadow-sm w-full">
            <img src={iconChip} alt="AI Icon" className="h-12 w-12 mr-6" />
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full">
              <h4 className="text-lg font-semibold text-[#1A1A1A] mb-2 sm:mb-0 sm:w-1/3">Edge + Artificial Intelligence</h4>
              <p className="text-[#4B4B4B] text-sm sm:w-2/3">
                Combines edge computing with AI to enable real-time decisions, faster response, and smarter automation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    </>
  );
};

export default EnergyHero;
